//hook
import { UserConsumer } from '../../hooks/context/UserContext';
import { useApi } from '../../hooks/useApi';

//type
import { completedDriverReqType, driverProfileType } from '../../api/completedRole/type/CompletedRoleType';

//api
import { PostCompletedRoleApi } from '../../api/completedRole/PostCompletedRoleApi';
import { GetProfileApi } from '../../api/profile/GetProfileApi';
import { UpdateCompletedRoleApi } from '../../api/completedRole/UpdateCompletedRoleApi';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//mui
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../../translate/i18n';

//mui date piker
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

//moment
import moment from 'moment';

//utils
import { convertUrlToFile } from '../../utils/convertUrlToFile';

interface driverFieldProps {
    setOpenCompletedProfile: (open: boolean) => void
    RoleLicenseFront: string,
    setRoleLicenseFront: (RoleLicenseFront: string) => void
    RoleLicenseBack: string,
    setRoleLicenseBack: (RoleLicenseBack: string) => void
    driverProfile: driverProfileType
    setDriverProfile:(clientProfile: driverProfileType) => void
    driverPichture: string,
    setDriverPichture: (driverPichture: string) => void
    themeRole: string
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

const CompletedDriverField = (
    {
    setOpenCompletedProfile, 
    RoleLicenseFront, 
    setRoleLicenseFront, 
    RoleLicenseBack, 
    setRoleLicenseBack, 
    driverProfile, 
    setDriverProfile,
    driverPichture, 
    setDriverPichture,
    themeRole
    }: driverFieldProps,
) => {
    const { t } = useTranslation();
    let {userData,setUserData} = UserConsumer()

    const {
        loading: postCompletedRoleLoading,
        error: postCompletedRoleError,
        HandlerApi: postCompletedRoleApi
    } = useApi(PostCompletedRoleApi, "Post");

    const {
        loading: updateCompletedRoleLoading,
        error: updateCompletedRoleError,
        HandlerApi: updateCompletedRoleApi
    } = useApi(UpdateCompletedRoleApi, "Post");
    
    //validation
    const driverSchema = Yup.object().shape({
        picture: Yup.mixed()
            .required(t("picture_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        hourly_desired_wage: Yup.number()
        .required(t("hourly_desired_wage_required"))
        .test("hourly_desired_wage_required", t("the_number_must_be_greater_than_zero"), (value) => {
            if (!value) return false;
            return value > 0;
        }),
        extra_hour_price: Yup.number()
        .required(t("extra_hour_price_required"))
        .test("extra_hour_price_required", t("the_number_must_be_greater_than_zero"), (value) => {
            if (!value) return false;
            return value > 0;
        }),
        preferred_start_time: Yup.mixed()
            .required(t("preferred_start_time_required"))
            .test(
            "is-valid-date",
            "Invalid date",
            value => moment(value, "HH:mm").isValid()),
        preferred_end_time: Yup.mixed()
            .required(t("preferred_end_time_required"))
            .test(
            "is-valid-date",
            "Invalid date",
            value => moment(value, "HH:mm").isValid()),
        front_license_image_url: Yup.mixed()
            .required(t("front_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        background_license_image_url: Yup.mixed()
            .required(t("background_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
    })

    // start functions
    
    const handleSubmit = async (values: completedDriverReqType, theme:string)=> {
        if ('picture' in values && typeof values.picture === "string") {
            values.picture = await convertUrlToFile(values.picture);
        }
        if ('front_license_image_url' in values && typeof values.front_license_image_url === "string") {
            values.front_license_image_url = await convertUrlToFile(values.front_license_image_url);
        }
        if ('background_license_image_url' in values && typeof values.background_license_image_url === "string") {
            values.background_license_image_url = await convertUrlToFile(values.background_license_image_url);
        }
        let result:any = ''
        if(userData?.is_driver) {
            result = await updateCompletedRoleApi(theme, values, driverProfile?.id);
        }
        else {
            result = await postCompletedRoleApi(theme, values);
        }
        if(result.code == 200 || result.code == 201) {
            setDriverPichture("")
            setRoleLicenseFront("")
            setRoleLicenseBack("")
            setOpenCompletedProfile(false)
            const resultprofile = await GetProfileApi();
            setUserData(resultprofile.data);
            setDriverProfile({   
                id: 0,
                picture_url: null,
                hourly_desired_wage: 0,
                extra_hour_price: 0,
                preferred_start_time: null,
                preferred_end_time: null,
                front_license_image_url: null,
                background_license_image_url: null
            })
        }
    }

    // end functions

    return (
        <div>
            <Formik
            enableReinitialize
            initialValues={{
                picture: driverProfile?.picture_url ?? null,
                hourly_desired_wage: driverProfile?.hourly_desired_wage ?? null,
                extra_hour_price: driverProfile?.extra_hour_price ?? null,
                preferred_start_time: driverProfile?.preferred_start_time ?? null,
                preferred_end_time: driverProfile?.preferred_end_time ?? null,
                front_license_image_url: driverProfile?.front_license_image_url ?? null,
                background_license_image_url: driverProfile?.background_license_image_url ?? null,
            }}
            validationSchema={driverSchema}
            onSubmit={(values)=>handleSubmit(values, themeRole)}
            >
            {({ values,touched, errors,setFieldValue, setFieldTouched}) => (
                <Form>
                    <div className="mb-5">
                        <div>
                            <Button
                                component="label"
                                className='!bg-paretnerColor !text-white w-fit !capitalize'
                                startIcon={<CloudUploadIcon />}
                            >
                                {t("profile_picture")}
                                <VisuallyHiddenInput
                                type="file"
                                accept="image/*"
                                onChange={(event) => {
                                    const file = event.target.files?.[0];
                                    if (file) {
                                    setFieldValue("picture", file);
                                    setDriverPichture(URL.createObjectURL(file));
                                    }
                                }}
                                />
                            </Button>
                        </div>
                        {/* Show selected image preview */}
                        { driverPichture
                            ? (
                                <img
                                src={driverPichture}
                                alt="Profile picture preview"
                                className="mt-3 w-40 h-28 object-cover rounded-lg border"
                                loading="lazy"
                                decoding="async"
                                />
                            ) 
                            : userData?.is_driver && driverProfile?.picture_url ? (
                                // Show existing uploaded image from backend
                                <img
                                src={`${storageURL}/${driverProfile?.picture_url}`}
                                alt="Profile picture preview"
                                className="mt-3 w-40 h-28 object-cover rounded-lg border"
                                loading="lazy"
                                decoding="async"
                                />
                            ) : null
                        }
                        <p className="text-[12px] mt-2 text-red-500">
                                {touched.picture && errors.picture ? errors.picture : ""}
                        </p>
                    </div>
                    <div>
                        <div className='flex gap-2 max-sm:flex-col'>
                            <Field
                                as={TextField}
                                type="number"
                                name="hourly_desired_wage"
                                label={t("hourly_desired_wage")}
                                className="sm:w-1/2 w-full !mb-2"
                                helperText={touched.hourly_desired_wage && errors.hourly_desired_wage ? errors.hourly_desired_wage : ""}
                                error={touched.hourly_desired_wage && Boolean(errors.hourly_desired_wage)}
                            />
                            <Field
                                as={TextField}
                                type="number"
                                name="extra_hour_price"
                                label={t("extra_hour_price")}
                                className="sm:w-1/2 w-full !mb-2"
                                helperText={touched.extra_hour_price && errors.extra_hour_price ? errors.extra_hour_price : ""}
                                error={touched.extra_hour_price && Boolean(errors.extra_hour_price)}
                            />
                        </div>
                        <div className='flex gap-2 max-sm:flex-col'>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <TimePicker
                                label={t("preferred_start_time")}
                                format="HH:mm" 
                                closeOnSelect={false}
                                value={values.preferred_start_time ? moment(values.preferred_start_time, "HH:mm") : null}
                                onChange={(value) => {
                                    setFieldValue("preferred_start_time", value ? value.format("HH:mm") : null);
                                }}
                                onClose={() => {
                                    setFieldTouched("preferred_start_time", true);
                                }}
                                slotProps={{
                                    textField: {
                                        helperText: values.preferred_start_time === null && touched.preferred_start_time && errors.preferred_start_time ? errors.preferred_start_time : null,
                                        error: values.preferred_start_time === null && touched.preferred_start_time && Boolean(errors.preferred_start_time),
                                        className: "w-full"
                                    }
                                }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <TimePicker
                                label={t("preferred_end_time")}
                                format="HH:mm" 
                                closeOnSelect={false}
                                value={values.preferred_end_time ? moment(values.preferred_end_time, "HH:mm") : null}
                                onChange={(value) => {
                                    setFieldValue("preferred_end_time", value ? value.format("HH:mm") : null);
                                }}
                                onClose={() => {
                                    setFieldTouched("preferred_end_time", true);
                                }}
                                slotProps={{
                                    textField: {
                                        helperText: values.preferred_end_time === null && touched.preferred_end_time && errors.preferred_end_time ? errors.preferred_end_time : null,
                                        error: values.preferred_end_time === null && touched.preferred_end_time && Boolean(errors.preferred_end_time),
                                        className: "w-full"
                                    }
                                }}
                                />
                            </LocalizationProvider>
                        </div>
                        
                    </div>
                    <div className="mt-5 flex max-sm:flex-col max-sm:items-center gap-5">
                        <div>
                            <Button
                                component="label"
                                className='!bg-paretnerColor !text-white w-fit !capitalize'
                                startIcon={<CloudUploadIcon />}
                            >
                                {t("front_side")}
                                <VisuallyHiddenInput
                                type="file"
                                accept="image/*"
                                onChange={(event) => {
                                    const file = event.target.files?.[0];
                                    if (file) {
                                    setFieldValue("front_license_image_url", file);
                                    setRoleLicenseFront(URL.createObjectURL(file));
                                    }
                                }}
                                />
                            </Button>
                            {/* Show selected image preview */}
                            {RoleLicenseFront
                                ? (
                                    <img
                                    src={RoleLicenseFront}
                                    alt="Front license preview"
                                    className="mt-3 w-40 h-28 object-cover rounded-lg border max-sm:mx-auto"
                                    loading="lazy"
                                    decoding="async"
                                    />
                                ) 
                                : userData?.is_driver && driverProfile?.front_license_image_url ? (
                                    // Show existing uploaded image from backend
                                    <img
                                    src={`${storageURL}/${driverProfile.front_license_image_url}`}
                                    alt="Front license uploaded"
                                    className="mt-3 w-40 h-28 object-cover rounded-lg border max-sm:mx-auto"
                                    loading="lazy"
                                    decoding="async"
                                    />
                                ) : null
                            }
                            <p className="text-[12px] mt-2 text-red-500">
                                {touched.front_license_image_url && errors.front_license_image_url ? errors.front_license_image_url : ""}
                            </p>
                        </div>
                        <div>
                            <Button
                                component="label"
                                className='!bg-paretnerColor !text-white w-fit !capitalize'
                                startIcon={<CloudUploadIcon />}
                            >
                                {t("back_side")}
                                <VisuallyHiddenInput
                                type="file"
                                accept="image/*"
                                onChange={(event) => {
                                    const file = event.target.files?.[0];
                                    if (file) {
                                    setFieldValue("background_license_image_url", file);
                                    setRoleLicenseBack(URL.createObjectURL(file));
                                    }
                                }}
                                />
                            </Button>
                            {/* Show selected image preview */}
                            {RoleLicenseBack 
                                ? (
                                    <img
                                    src={RoleLicenseBack}
                                    alt="Back license preview"
                                    className="mt-3 w-40 h-28 object-cover rounded-lg border max-sm:mx-auto"
                                    loading="lazy"
                                    decoding="async"
                                    />
                                ) 
                                : userData?.is_driver && driverProfile?.background_license_image_url ? (
                                    // Show existing uploaded image from backend
                                    <img
                                    src={`${storageURL}/${driverProfile.background_license_image_url}`}
                                    alt="Back license uploaded"
                                    className="mt-3 w-40 h-28 object-cover rounded-lg border max-sm:mx-auto"
                                    loading="lazy"
                                    decoding="async"
                                    />
                                ) : null
                            }
                            <p className="text-[12px] mt-2 text-red-500">
                                {touched.background_license_image_url && errors.background_license_image_url ? errors.background_license_image_url : ""}
                            </p>
                        </div>
                    </div>
                    <hr className='mt-5'/>
                    <DialogActions className={i18n.language === "en" ? "!justify-start" : "!justify-start"}>
                        <Button className='w-full !bg-paretnerColor !text-white !rounded-full' type="submit">
                            {postCompletedRoleLoading || updateCompletedRoleLoading 
                            ? <CircularProgress className='w-1 h-1'/>
                            :userData?.is_driver ? t("update") : t("confirm")
                            }
                        </Button>
                    </DialogActions>
                </Form>
            )}
            </Formik>
        </div>
    )
}

export default CompletedDriverField